import { Avatar, Flex, Image, Modal, UnstyledButton } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

export default function TableImageViewer({ url }) {
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      <Flex justify="center">
        <UnstyledButton onClick={open}>
          <Avatar src={url} alt="hello" radius="sm" />
        </UnstyledButton>
      </Flex>

      <Modal opened={opened} onClose={close} title="이미지 상세 보기" size="lg">
        <Image src={url} alt="hello" withPlaceholder />
      </Modal>
    </>
  );
}
